import { convertDateToDateOnlyString } from "@insite/client-framework/Common/Utilities/DateUtilities";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getReviewAndPayCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getReviewAndPayPromotions } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import clearMessages from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ClearMessages";
import loadDataIfNeeded from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadDataIfNeeded";
import notifyProductRecs from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/NotifyProductRecs";
import setCartId from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetCartId";
import setPlaceOrderErrorMessage from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetPlaceOrderErrorMessage";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressErrorModal from "@insite/content-library/Components/AddressErrorModal";
import Page from "@insite/mobius/Page";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import loadWORCarriers from "@tKgpco/Handlers/WORLoadCarrires";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { createContext, useContext, useEffect, useReducer } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    loadWORCarriers,
    searchFilterAccessorials,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoadingCarriers: state.KGPState.worCarriers.isLoading,
});

type Props = PageProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const releaseOrderReducer = (state: any, action: any) => {
    switch (action.type) {
        case "SET_DATA":
            return {
                ...state,
                ...action.payload,
            };
        case "SET_REQUESTED_DELIVERY_DATE":
            // eslint-disable-next-line no-case-declarations
            const reqDelDate = action.payload;
            // eslint-disable-next-line no-case-declarations
            const earliestShipDate = new Date();
            // earliestShipDate.setMonth(reqDelDate.getMonth(),reqDelDate.getDate() + 1);
            return {
                ...state,
                requestedDeliveryDate: convertDateToDateOnlyString(reqDelDate),
                earliestShipDate: "",
                minEarliestShipDate: convertDateToDateOnlyString(earliestShipDate),
            };
        default:
            return state;
    }
};

const WORContext = createContext<any>([null, () => {}]);

export const useWORContext = () => {
    const ctx = useContext(WORContext);

    if (!ctx) {
        throw new Error("Accessing WORContext outside scope!");
    }
    return ctx;
};

const WORCheckoutReviewSubmitPage = ({ id, loadWORCarriers, isLoadingCarriers, searchFilterAccessorials }: Props) => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const initialearliestShipDate = new Date();
    initialearliestShipDate.setDate(tomorrow.getDate() + 1);
    const requestedDeliveryDate = convertDateToDateOnlyString(undefined);
    const earliestShipDate = convertDateToDateOnlyString(initialearliestShipDate);
    const minEarliestShipDate = convertDateToDateOnlyString(initialearliestShipDate);
    const [worData, worDispatch] = useReducer(releaseOrderReducer, {
        requestedDeliveryDate,
        earliestShipDate,
        minEarliestShipDate,
    });
    useEffect(() => {
        if (!isLoadingCarriers) {
            loadWORCarriers();
            // searchFilterAccessorials({ queryParams: { enabled: true } });
        }
    }, []);

    return (
        <Page>
            <WORContext.Provider value={{ worData, worDispatch }}>
                <Zone zoneName="Content" contentId={id} />
                <AddressErrorModal />
            </WORContext.Provider>
        </Page>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(WORCheckoutReviewSubmitPage),
    definition: {
        displayName: "WOR Checkout Review Page",
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
